import React from 'react';
import PropTypes from 'prop-types';

import {black500, green500, red500} from "assets/jss/main";

ReferenceCount.propTypes = {
    importReport: PropTypes.shape({
        referenceCount: PropTypes.number
    }),
    variationPercentage: PropTypes.number
};

function ReferenceCount({importReport = null, variationPercentage = null}) {
    if (importReport === null || importReport?.referenceCount === null) {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <span style={{
                fontSize: '14px',
                fontWeight: 600,
                color: black500
            }}>
                {importReport.referenceCount}
            </span>
            {variationPercentage !== null && (
                <span style={{
                    fontSize: '12px',
                    color: variationPercentage === 0 ? black500 : variationPercentage < 0 ? red500 : green500
                }}>
                    {variationPercentage > 0 ? '+' : ''}{variationPercentage}% vs dernier import
                </span>
            )}
        </div>
    );
}

export default ReferenceCount;
